import {PARAMETERS} from "config/parameters";

export const CONFIG = {
    ENVIRONMENT: {
        REDUX_LOGGER: PARAMETERS.REDUX_LOGGER || false,
        REDUX_DEVTOOLS: PARAMETERS.REDUX_DEVTOOLS || false,
        REDUX_MONITOR: PARAMETERS.REDUX_MONITOR || false,
    },
    PANEL_URL: PARAMETERS.PANEL_URL || '#',
    APP_ID: PARAMETERS.APP_ID || {},
    TAWK: {
        IS_ENABLED: PARAMETERS.TAWK.IS_ENABLED || false,
        POLISH_CHANNEL: PARAMETERS.TAWK.POLISH_CHANNEL,
        ENGLISH_CHANNEL: PARAMETERS.TAWK.ENGLISH_CHANNEL,
        RUSSIAN_CHANNEL: PARAMETERS.TAWK.RUSSIAN_CHANNEL,
        UKRAINIAN_CHANNEL: PARAMETERS.TAWK.UKRAINIAN_CHANNEL,
    },
    DEFAULT_COOKIE_DOMAIN: PARAMETERS.DEFAULT_COOKIE_DOMAIN || null,
};
